export enum UITypes {
	PRIMARY = 'primary',
	MAIN = 'main',
	WARNING = 'warning',
	DANGER = 'danger',
	INFO = 'info',
	PASSIVE = 'passive',
	BLUE = 'blue',
	BLACK = 'black',
	SUCCESS = 'success',
	WHITE = 'white',
	GREY = 'grey',
	GREY_LIGHT = 'greyLight',
	VIOLET = 'violet',
}

export enum UISizes {
	NORMAL = 'normal',
	BIG = 'big',
	RECTANGLE = 'rectangle',
	SMALL = 'small',
	MEDIUM = 'medium',
	MAIN = 'main',
	LARGE = 'large',
	EXTRASMALL = 'extraSmall',
	XXS = 'XXS',
}

export enum DatePickerType {
	DEFAULT = 'default',
	MONTH = 'month',
	RANGE = 'range',
}

export enum UICurrencySuffix {
	DEFAULT = ' ₽',
	NONE = '',
}

export enum UIPlacement {
	TOP = 'top',
	TOP_LEFT = 'topLeft',
	TOP_RIGHT = 'topRight',
	RIGHT = 'right',
	RIGHT_TOP = 'rightTop',
	RIGHT_BOTTOM = 'rightBottom',
	BOTTOM = 'bottom',
	BOTTOM_LEFT = 'bottomLeft',
	BOTTOM_RIGHT = 'bottomRight',
	LEFT = 'left',
	LEFT_TOP = 'leftTop',
	LEFT_BOTTOM = 'leftBottom',
}

export enum UIDirection {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
}

export enum UITrigger {
	CLICK = 'click',
	HOVER = 'hover',
}

export enum UIHtmlType {
	SUBMIT = 'submit',
	BUTTON = 'button',
}
